import React, {useCallback} from "react";
import Icon from "../../atoms/icon/icon.component.js";
import {BreadcrumbsContainer, BreadcrumbsLinkContainer, BreadcrumbsTypographyContainer} from "./breadcrumbs.styles.js";
function Breadcrumbs({
  breadcrumbs
}) {
  const parsePoint = useCallback(({
    name,
    href,
    icon,
    color = "inherit",
    onClick
  }, index, arr) => {
    const isLast = index === arr.length - 1;
    const IconComponent = icon ? /* @__PURE__ */ React.createElement(Icon, {
      size: "small"
    }, icon) : void 0;
    const LinkComponent = /* @__PURE__ */ React.createElement(BreadcrumbsLinkContainer, {
      key: index.toString(),
      href,
      color,
      onClick
    }, IconComponent, name);
    const LastComponent = /* @__PURE__ */ React.createElement(BreadcrumbsTypographyContainer, {
      key: index.toString(),
      color: "text.primary",
      onClick
    }, IconComponent, name);
    return isLast ? LastComponent : LinkComponent;
  }, []);
  return /* @__PURE__ */ React.createElement(BreadcrumbsContainer, {
    "aria-label": "breadcrumb",
    separator: /* @__PURE__ */ React.createElement(Icon, {
      size: "small"
    }, "navigate_next")
  }, breadcrumbs.map(parsePoint));
}
export default /* @__PURE__ */ React.memo(Breadcrumbs);
